import { render } from "./PrintList.vue?vue&type=template&id=2a9661d6&scoped=true"
import script from "./PrintList.vue?vue&type=script&lang=js"
export * from "./PrintList.vue?vue&type=script&lang=js"

import "./PrintList.vue?vue&type=style&index=0&id=2a9661d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9661d6"]])

export default __exports__